import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import { Neo } from "@singularsystems/neo-react";
import { EnumHelper } from "@singularsystems/neo-core";
import { SystemNoteType } from "../../../Domain/Models/Catalogue/Generic/NoteType";
import AuditTrailRemindersCriteria from "./AuditTrailRemindersCriteria";

@NeoReport("AuditTrailRemindersReport", { category: ReportCategory.SystemReports })
export default class AuditTrailRemindersReport extends Report<AuditTrailRemindersCriteria> {

    constructor() {
        super(AuditTrailRemindersCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.FormGroup bind={this.criteria.meta.grouping} select={{ items: EnumHelper.asList(SystemNoteType) }} />
        </div>;
    }
}